var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-qr-code-wrapper"},[_c('vue-qrcode',{attrs:{"value":_vm.url,"width":140,"margin":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }